import EnableAutomaticInvoicingError from './EnableAutomaticInvoicingError';
class InvalidTaxId extends EnableAutomaticInvoicingError {
    constructor(options) {
        super('Investor trying to set a tax id with invalid format', options);
    }
}
export default InvalidTaxId;
